export default __webpack_public_path__ + "static/media/logo-light.5d1eeb5f.svg";